import { Component, OnInit, TemplateRef, trigger, state, style, transition, animate } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';

import { Observable } from "rxjs";
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { AngularFireAuth } from 'angularfire2/auth';

import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { FirebaseApp } from 'angularfire2';

// Service 
import { CartService } from '../services/cart.service'
import { AuthService } from '../services/AuthService'
import { SearchItemService } from '../services/searchService';
import { ServiceHeader } from '../services/serviceHeader';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  public modalRef: BsModalRef;
  public count: number = 0;
  showtab;

  public itemDropdown;
  // create user show on nav
  username: any;
  imgPath: any;
  email: any;
  // create formgrop 
  // create Error 
  error: any;
  checkUser: any;
  dataUser: any;
  checklogin: boolean;
  show: boolean;
  public text;
  /// เก็บค่าไว้ใน local ///
  isCollapsed = true;

  cheShowHide = true;
  dShowHide = false;
  constructor(private route: ActivatedRoute, private serHead: ServiceHeader, private searc: SearchItemService, private cartService: CartService, public router: Router, private modalService: BsModalService, public authService: AuthService, private fb: FormBuilder
    ,private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {

  }
  ngOnInit(): void {
    let snap = this.af.list('Menu');
    snap.subscribe((snapitem) => {
      this.itemDropdown = snapitem;
    })
  }
  HideD() {
    this.dShowHide = !this.dShowHide;
  }
  HideHeader() {
    this.cheShowHide = !this.cheShowHide;
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
  }
  eventHandler(e) {
    if (this.text.length > 0) {
      this.router.navigate(['/Search', { dataName: this.text }])
    } else {
      this.router.navigate(['/'])
    }
  }
  
  // logOut Page 
  logOut() {
    this.authService.logout()
    window.location.href = ''
  }
  // Register User 
  active = true;
  showClass = true;
  showdropdownlang = true;
  showActivetab(tab: string) {
    localStorage.setItem("showtab", tab);
    this.showtab = localStorage.getItem("showtab");
    // this.showtab = tab;
    if (tab != 'tab1') {
      this.showClass = false;
    }
  }
  dropdown;
  drop(name: string) {
    this.showdropdownlang = !this.showdropdownlang;
    this.dropdown = name;
    // if(name == 'lang')
  }
  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/header/header.component.ts